import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { handleStateChangeFromProps, getCurrencyCodes } from '../../libs/helpers';
import TextInput from '../../libs/TextInput';
import AutocompleteInput from '../../libs/AutocompleteInput';
import SelectInput from '../../libs/SelectInput';

class InstitutionBankInfo extends React.Component {
  state = {
    form: {},
    errors: {},
    onChange: null,
  }
  /*
   -----------------------------------------------------------------------
   RENDER Functions
   -----------------------------------------------------------------------
   */
  static getDerivedStateFromProps(nextProps, prevState) {
    return handleStateChangeFromProps(nextProps, prevState)
  }
  render() {
    const { errors, form } = this.state;
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Bank Information
        </Typography>
        <Grid container spacing={3}>
          <TextInput
            width={6}
            value={form.bank_name}
            onChange={this.props.onChange}
            name='bank_name'
            title='Bank Name'
            error={errors.bank_name}
            enabled={errors.enabled}
          />
          <TextInput
            width={6}
            value={form.bank_swift_bic}
            onChange={this.props.onChange}
            name='bank_swift_bic'
            title='Bank Swift/BIC'
            error={errors.bank_swift_bic}
            enabled={errors.enabled}
          />
          <AutocompleteInput
            width={6}
            value={form.bank_country_id}
            onChange={this.props.onChange}
            name='bank_country_id'
            title='Bank Country'
            error={errors.bank_country_id}
            enabled={errors.enabled}
            data='countries'
          />
          <TextInput
            width={6}
            value={form.bank_city}
            onChange={this.props.onChange}
            name='bank_city'
            title='Bank City'
            error={errors.bank_city}
            enabled={errors.enabled}
          />
          <TextInput
            width={6}
            value={form.bank_address}
            onChange={this.props.onChange}
            name='bank_address'
            title='Bank Address'
            error={errors.bank_address}
            enabled={errors.enabled}
          />

          <TextInput
            width={6}
            value={form.bank_postal_code}
            onChange={this.props.onChange}
            name='bank_postal_code'
            title='Bank Postal Code'
            error={errors.bank_postal_code}
            enabled={errors.enabled}
          />
          <TextInput
            width={6}
            value={form.bank_phone_number}
            onChange={this.props.onChange}
            name='bank_phone_number'
            title='Bank Phone Number'
            error={errors.bank_phone_number}
            enabled={errors.enabled}
          />
          <SelectInput
            width={6}
            value={form.main_currency}
            onChange={this.props.onChange}
            name='main_currency'
            title='Main Currency'
            error={errors.main_currency}
            enabled={errors.enabled}
            data={getCurrencyCodes()}
          />
          <TextInput
            width={6}
            value={form.branch_bank_name}
            onChange={this.props.onChange}
            name='branch_bank_name'
            title='Branch Name'
            error={errors.branch_bank_name}
            enabled={errors.enabled}
          />
          <TextInput
            width={6}
            value={form.branch_bank_swift_bic}
            onChange={this.props.onChange}
            name='branch_bank_swift_bic'
            title='Branch Swift/BIC'
            error={errors.branch_bank_swift_bic}
            enabled={errors.enabled}
          />
          <TextInput
            width={6}
            value={form.branch_phone_number}
            onChange={this.props.onChange}
            name='branch_phone_number'
            title='Branch Phone Number'
            error={errors.branch_phone_number}
            enabled={errors.enabled}
          />
          <TextInput
            width={6}
            value={form.short_code}
            onChange={this.props.onChange}
            name='short_code'
            title='Short Code'
            error={errors.short_code}
            enabled={errors.enabled}
          />

        </Grid>
      </React.Fragment>
    );
  }
}

export default InstitutionBankInfo;